import React from 'react';
import { Container } from 'react-bootstrap';
import Particle from '../Particle';
import BlogCard from './BlogCard';
const Blogs = () => {
  const blogs = [
    {
      title: 'Redux Middleware',
      content:
        'In this article, let us look at the Redux middleware feature in-depth, to understand its potential in better view.',
      tag: 'Redux',
      url: 'https://www.infinijith.com/blog/redux/redux-middleware',
    },
    {
      title: 'Redux in React – A Complete Guide ',
      content:
        'Let’s look at some fundamental principles of Redux and the demonstration of how to use Redux in React. ',
      tag: 'React',
      url: 'https://www.infinijith.com/blog/react/react-redux',
    },
    {
      title: 'React Hooks - A Complete Guide For 2023 (Part – 2) ',
      content:
        'In this article, we will explore the types, rules, and a profound analysis of the react additional hooks. ',
      tag: 'React',
      url: 'https://www.infinijith.com/blog/react/react-additional-hooks',
    },
    {
      title: 'React Hooks - A Complete Guide For 2023 (Part – 1) ',
      content:
        'The focus of this article is to explore the nuances of Hooks and their types, rules, and a profound analysis of the basic hooks. ',
      tag: 'React',
      url: 'https://www.infinijith.com/blog/react/react-basic-hooks',
    },
    {
      title: 'React Vs Vue – Best Frontend Framework for 2023 ',
      content:
        'React & Vue are the two popular front-end development technologies preferred by developers. Let’s compare these to find the best one.',
      tag: 'React',
      url: 'https://www.infinijith.com/blog/react/react-vs-vue',
    },
    {
      title: 'Cross-Origin Resource Sharing - How to Solve CORS Errors',
      content:
        'All developers must have faced the CORS errors. What is CORS and how CORS errors occur? Let us discuss this concept in detail.',
      tag: 'Web Security',
      url: 'https://www.infinijith.com/blog/web-security/cors',
    },
    {
      title: 'A Complete Guide to Redis Cache in Express Node JS ',
      content:
        'This article discusses the Redis caching concept in express Nodejs. With the example, get started with Redis concept. ',
      tag: 'Node JS',
      url: 'https://www.infinijith.com/blog/nodejs/redis-cache-in-express-nodejs',
    },
    {
      title: 'Node-Cache with Express Node JS ',
      content:
        'Node Cache is one of the interesting concepts to increase performance of NodeJS application. Let us discuss it with an example. ',
      tag: 'Node JS',
      url: 'https://www.infinijith.com/blog/nodejs/node-cache',
    },
    {
      title: 'Communication between Microservices ',
      content:
        'In this article, we will learn about different ways of communication between microservices. ',
      tag: 'Node JS',
      url: 'https://www.infinijith.com/blog/nodejs/microservices-communication',
    },
    {
      title: 'Advantages of Using Microservices in Node JS ',
      content:
        'Microservice architecture in NodeJS helps to improve the app performance. Let us discuss this topic in detail with an example.',
      tag: 'Node JS',
      url: 'https://www.infinijith.com/blog/nodejs/microservices-in-nodejs',
    },
    {
      title: 'Optimizing App Performance with Nodejs Cluster',
      content:
        'App performance is so important! Learn how to optimize nodejs app performance with clustering concept.',
      tag: 'Node JS',
      url: 'https://www.infinijith.com/blog/nodejs/nodejs-cluster',
    },
  ];

  return (
    <Container fluid className="blog-section">
      <Particle />
      <Container>
        <h1 className="sub-heading">
          My <strong className="text-color">Blogs </strong>
        </h1>
        <div className="px-0.5 md:px-7 pb-14 pt-6 mx-auto">
          <div className="flex flex-wrap">
            {blogs &&
              blogs.map((blog, index) => <BlogCard key={index} blog={blog} />)}
          </div>
        </div>
      </Container>
    </Container>
  );
};

export default Blogs;
